export default __webpack_public_path__ + "static/media/checkout_3.76547777.png";